<template>
  <div class="mt-4">
    <span for="points">( {{ $t('* https://www.youtube.com/embed/') }}</span
    ><strong
      style="font-size: 15px;
    color: black;"
      >VIDEO_ID</strong
    >)
    <div class="form-control" :class="{ 'has-error': errors.has('buttonLink') }">
      <textarea
        name="VIDEO_ID"
        key="VIDEO_ID"
        :data-vv-name="'VIDEO_ID'"
        rows="10"
        class="form-control"
        style="width: 100%; resize: vertical; height: 50px;"
        v-model="value.url"
        :data-vv-as="$t('VIDEO_ID')"
        placeholder="VIDEO_ID"
        maxlength="25"
      ></textarea>
      <span class="text-error" v-show="errors.has('buttonLink')">{{
        errors.first('buttonLink')
      }}</span>
    </div>

    <span>{{ $t('set_youtube_play') }}</span> <small>({{ $t('youtube_remark') }})</small>
    <v-checkbox
      class="mt-0"
      v-model="value.autoplay"
      color="primary"
      :label="$t('auto_play')"
    ></v-checkbox>
    <v-checkbox
      class="mt-0"
      v-model="value.loop"
      color="primary"
      :label="$t('set_loop')"
    ></v-checkbox>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {}
  },
  components: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/salePage/templateType/Youtube.vue